
<!-- ============================================================== -->
<!-- Left Sidebar - style you can find in sidebar.scss  -->
<!-- ============================================================== -->
<aside class="left-sidebar" style="background-color: brown;">
    <!-- Sidebar scroll-->
    <div class="scroll-sidebar" style="background-color: brown;">
        <!-- Sidebar navigation-->
        <nav class="sidebar-nav" style="background-color: brown;">
            <ul id="sidebarnav">

                <li class="nav-small-cap" style="text-align: center; padding: 15px 0 1px 0;">
                    <img src="./assets/images/NuevoSICAI2.png" alt="Logo SICAI" style="width: 85%; max-width: 170px;">
                </li>    

                <!-- <li class="nav-devider"></li> -->

                <li *ngFor="let item of menuItems" style="margin-top: 30px;">
                    <a class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false" style="text-decoration:none;  background-color: brown;">
                        <i class="mdi mdi-store" style="color: #FFF;"></i>
                        
                        <span class="hide-menu" style="color:#FFF; background-color: brown;" onmouseover="this.style.cssText='color:Orange'" onmouseout="this.style.cssText='color:white'"> 
                            {{ item.titulo }} 
                            <span id="uno" class="label label-rouded label-themecolor pull-right" style="background-color: rgb(103, 101, 101)">
                                {{ item.submenu.length }}
                            </span>
                        </span>
                    </a>

                    <ul aria-expanded="false" class="collapse" style="background-color: brown;">
                        <li *ngFor="let subMenuItem of item.submenu">
                            <a *ngIf="subMenuItem.mostrar" [routerLink]="subMenuItem.url" style="text-decoration:none;color: #FFF;  background-color: brown;" onmouseover="this.style.cssText='color:orange'" onmouseout="this.style.cssText='color:white'"> * {{ subMenuItem.titulo }} </a>
                        </li>
                    </ul>
                </li>


                <!-- <li *ngFor="let item2 of menuItems2">
                    <a class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false" style="text-decoration:none; background-color: brown">
                        <i class="mdi mdi-file-find" style="color: #FFF; background-color: brown"></i>
                        <span class="hide-menu" style="color: #FFF; background-color: brown"> 
                            {{ item2.titulo }} 
                            
                            <span class="label label-rouded label-themecolor pull-right" style="background-color: rgb(103, 101, 101)">
                                {{ item2.submenu.length }}
                            </span>
                        </span>
                    </a>

                    <ul aria-expanded="false" class="collapse" style="background-color: brown">
                        <li *ngFor="let subMenuItem of item2.submenu">
                            <a [routerLink]="subMenuItem.url" style="text-decoration:none;color: #FFF; background-color: brown"> * {{ subMenuItem.titulo }} </a>
                        </li>
                    </ul>
                </li> -->


                <!--************ STARTED TRANSFERENCIAS *********--> 

                <li *ngFor="let item3 of menuItems3">
                    <a *ngIf="vertransferencias" class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false" style="text-decoration:none; background-color: brown">
                        <i class="mdi mdi-repeat" style="color: #FFF; background-color: brown"></i>
              
                        <span class="hide-menu" style="color: #FFF; background-color: brown;" onmouseover="this.style.cssText='color:Orange'" onmouseout="this.style.cssText='color:white'"> 
                            {{ item3.titulo }} 
                            <span class="label label-rouded label-themecolor pull-right" style="background-color: rgb(103, 101, 101)">
                                {{ item3.submenu.length }}
                            </span>
                        </span>
                    </a>

                    <ul aria-expanded="false" class="collapse" style="background-color: brown">
                        <li *ngFor="let subMenuItem of item3.submenu">
                            <a  [routerLink]="subMenuItem.url" style="text-decoration:none;color: #FFF; background-color: brown" onmouseover="this.style.cssText='color:orange'" onmouseout="this.style.cssText='color:white'"> * {{ subMenuItem.titulo }} </a>
                        </li> 
                    </ul>
                </li>

                  <!-- ********** STARTED REQUISIONES *************-->

                <li *ngFor="let item4 of menuItems4">    

                    <a class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false" style="text-decoration:none; background-color: brown">
                        <i class="mdi mdi-file-document" style="color: #FFF; background-color: brown"></i>
                        <span class="hide-menu" style="color: #FFF; background-color: brown" onmouseover="this.style.cssText='color:orange'" onmouseout="this.style.cssText='color:white'"> 
                            {{ item4.titulo }} 
                            <span class="label label-rouded label-themecolor pull-right" style="background-color: rgb(103, 101, 101)">
                                {{ item4.submenu.length }}
                            </span>
                        </span>
                    </a>

                    <ul aria-expanded="false" class="collapse" style="background-color: brown">
                        <li *ngFor="let subMenuItem of item4.submenu">
                            <a *ngIf="subMenuItem.mostrar" [routerLink]="subMenuItem.url" style="text-decoration:none;color: #FFF; background-color: brown" onmouseover="this.style.cssText='color:orange'" onmouseout="this.style.cssText='color:white'"> * {{ subMenuItem.titulo }} </a>
                        </li>
                    </ul>
                </li>

                <!-- Menu Articulos -->

                  <li *ngFor="let item55 of menuItems55">    

                    <a *ngIf="verArticulos" class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false" style="text-decoration:none; background-color: brown">
                        <i class="mdi mdi-view-module" style="color: #FFF; background-color: brown"></i>
                        <span class="hide-menu" style="color: #FFF; background-color: brown" onmouseover="this.style.cssText='color:orange'" onmouseout="this.style.cssText='color:white'"> 
                            {{ item55.titulo }} 
                            <span class="label label-rouded label-themecolor pull-right" style="background-color: rgb(103, 101, 101)">
                                {{ item55.submenu.length }}
                            </span>
                        </span>
                    </a>

                    <ul aria-expanded="false" class="collapse" style="background-color: brown">
                        <li *ngFor="let subMenuItem of item55.submenu">
                            <a *ngIf="subMenuItem.mostrar" [routerLink]="subMenuItem.url" style="text-decoration:none;color: #FFF; background-color: brown" onmouseover="this.style.cssText='color:orange'" onmouseout="this.style.cssText='color:white'"> * {{ subMenuItem.titulo }} </a>
                        </li>
                    </ul>
                </li>





                <!-- REPORTES -->

                <li *ngFor="let item44 of menuItems44">    

                    <a *ngIf="verReportes" class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false" style="text-decoration:none; background-color: brown">
                        <i class="mdi mdi-chart-areaspline" style="color: #FFF; background-color: brown"></i>
                        <span class="hide-menu" style="color: #FFF; background-color: brown" onmouseover="this.style.cssText='color:orange'" onmouseout="this.style.cssText='color:white'"> 
                            {{ item44.titulo }} 
                            <span class="label label-rouded label-themecolor pull-right" style="background-color: rgb(103, 101, 101)">
                                {{ item44.submenu.length }}
                            </span>
                        </span>
                    </a>

                    <ul aria-expanded="false" class="collapse" style="background-color: brown">
                        <li *ngFor="let subMenuItem of item44.submenu">
                            <a *ngIf="subMenuItem.mostrar" [routerLink]="subMenuItem.url" style="text-decoration:none;color: #FFF; background-color: brown" onmouseover="this.style.cssText='color:orange'" onmouseout="this.style.cssText='color:white'"> * {{ subMenuItem.titulo }} </a>
                        </li>
                    </ul>
                </li>


                <li *ngFor="let item6 of menuItems6">
                    <a *ngIf="movimientos" class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false" style="text-decoration:none; background-color: brown">
                        <i class="mdi mdi-account-convert" style="color: #FFF; background-color: brown"></i>
                        <span class="hide-menu" style="color: #FFF; background-color: brown"> 
                            {{ item6.titulo }} 
                            <span class="label label-rouded label-themecolor pull-right" style="background-color: rgb(103, 101, 101)">
                                {{ item6.submenu.length }}
                            </span>
                        </span>
                    </a>

                    <ul aria-expanded="false" class="collapse" style="background-color: brown">
                        <li *ngFor="let subMenuItem of item6.submenu">
                            <a *ngIf="subMenuItem.mostrar" [routerLink]="subMenuItem.url" style="text-decoration:none;color: #FFF; background-color: brown"> * {{ subMenuItem.titulo }} </a>
                        </li>
                    </ul>
                </li>



            <!-- usuarios -->


                <li *ngFor="let item5 of menuItems5">
                    <a class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false" style="text-decoration:none; background-color: brown">
                        <i class="mdi mdi-account-multiple" style="color: #FFF; background-color: brown"></i>
                        <!-- <i class="mdi mdi-cash-usd" style="color: #FFF; background-color: brown"></i> -->
                        <span class="hide-menu" style="color: #FFF; background-color: brown" onmouseover="this.style.cssText='color:orange'" onmouseout="this.style.cssText='color:white'"> 
                            {{ item5.titulo }} 
                            <span class="label label-rouded label-themecolor pull-right" style="background-color: rgb(103, 101, 101)">
                                {{ item5.submenu.length }}
                            </span>
                        </span>
                    </a>

                    <ul aria-expanded="false" class="collapse" style="background-color: brown">
                        <li *ngFor="let subMenuItem of item5.submenu">
                            <a [routerLink]="subMenuItem.url" style="text-decoration:none;color: #FFF; background-color: brown" onmouseover="this.style.cssText='color:orange'" onmouseout="this.style.cssText='color:white'"> * {{ subMenuItem.titulo }} </a>
                        </li>
                    </ul>
                </li>

                <!-- <li *ngFor="let item7 of menuItems7">
                    <a *ngIf="PermisosModulos" class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false" style="text-decoration:none; background-color: brown">
                        <i class="mdi mdi-account-settings-variant" style="color: #FFF; background-color: brown"></i>
                        <span class="hide-menu" style="color: #FFF; background-color: brown"> 
                            {{ item7.titulo }} 
                            <span class="label label-rouded label-themecolor pull-right" style="background-color: rgb(103, 101, 101)">
                                {{ item7.submenu.length }}
                            </span>
                        </span>
                    </a>

                    <ul aria-expanded="false" class="collapse" style="background-color: brown">
                        <li *ngFor="let subMenuItem of item7.submenu">
                            <a *ngIf="subMenuItem.mostrar" [routerLink]="subMenuItem.url" style="text-decoration:none;color: #FFF; background-color: brown"> * {{subMenuItem.titulo }} </a>
                        </li>
                    </ul>
                </li> -->

                <!-- <li *ngFor="let item8 of menuItems8">
                    <a *ngIf="Ajedrez" class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false" style="text-decoration:none; background-color: brown">
                        <i class="mdi mdi-checkerboard" style="color: #FFF; background-color: brown"></i>
                        <span class="hide-menu" style="color: #FFF; background-color: brown"> 
                            {{ item8.titulo }} 
                            <span class="label label-rouded label-themecolor pull-right" style="background-color: rgb(103, 101, 101)">
                                {{ item8.submenu.length }}
                            </span>
                        </span>
                    </a>

                    <ul aria-expanded="false" class="collapse" style="background-color: brown">
                        <li *ngFor="let subMenuItem of item8.submenu">
                            <a *ngIf="subMenuItem.mostrar" [routerLink]="subMenuItem.url" style="text-decoration:none;color: #FFF; background-color: brown"> * {{subMenuItem.titulo }} </a>

                            <li *ngIf="linksajedrez">
                                <a style="color: white;" href="https://cecyteveracruzedu-my.sharepoint.com/:x:/r/personal/sistemas_cecytev_edu_mx/Documents/Ajedrez/Formato%20base%20Acreditados,%20No%20Acreditados,%20Caso%20Especial.xlsx?d=w011975fefe924aa0b3d89b59ae43361d&csf=1&web=1&e=g2U4EM"
                                    target="_blank"><i class="fa fa-file-excel-o fa-1.5x"></i> Formato Base acreditado, No acreditado. Caso especial</a>
                            </li>


                    </ul>
                    </li> -->


                    <!-- <li *ngFor="let item9 of menuItems9">
                        <a *ngIf="descargas" class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false" style="text-decoration:none; background-color: brown">
                            <i class="mdi mdi-folder-download" style="color: #FFF; background-color: brown"></i>
                            <span class="hide-menu" style="color: #FFF; background-color: brown"> 
                            {{ item9.titulo }} 
                            <span class="label label-rouded label-themecolor pull-right" style="background-color: rgb(103, 101, 101)">
                                {{ item9.submenu.length }}
                            </span>
                            </span>
                        </a>

                        <ul aria-expanded="false" class="collapse" style="background-color: brown">
                            <li *ngFor="let subMenuItem of item9.submenu">
                                <a *ngIf="subMenuItem.mostrar" [routerLink]="subMenuItem.url" style="text-decoration:none;color: #FFF; background-color: brown"> * {{subMenuItem.titulo }} </a>
                            </li>
                            <li><a style="color: white;" (click)="alumnos()" target="_blank"><i class="fa fa-file-excel-o fa-1.5x"></i> Alumnos</a></li>
                            <li><a style="color: white;" (click)="Submodulos()" target="_blank"><i class="fa fa-file-excel-o fa-1.5x"></i> Calificación Submódulos</a></li>
                            <li><a style="color: white;" (click)="Asignaturas()" target="_blank"><i class="fa fa-file-excel-o fa-1.5x"></i> Calificación Asignaturas</a></li>
                            <li><a style="color: white;" (click)="Extracurricular()" target="_blank"><i class="fa fa-file-excel-o fa-1.5x"></i> Calificación Extracurricular</a></li>


                        </ul>
                    </li> -->

                    <li *ngFor="let item10 of menuItems10">
                    <a class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false" style="text-decoration:none; background-color: brown">
                        <i class="mdi mdi-key" style="color: #FFF; background-color: brown"></i>
                        <span class="hide-menu" style="color: #FFF; background-color: brown" onmouseover="this.style.cssText='color:orange'" onmouseout="this.style.cssText='color:white'"> 
                            {{ item10.titulo }} 
                            <span class="label label-rouded label-themecolor pull-right" style="background-color: rgb(103, 101, 101)">
                                {{ item10.submenu.length }}
                            </span>
                        </span>
                    </a>

                    <ul aria-expanded="false" class="collapse" style="background-color: brown">
                        <li *ngFor="let subMenuItem of item10.submenu">
                            <a [routerLink]="subMenuItem.url" style="text-decoration:none;color: #FFF; background-color: brown" onmouseover="this.style.cssText='color:orange'" onmouseout="this.style.cssText='color:white'"> * {{ subMenuItem.titulo }} </a>
                        </li>
                    </ul>
                </li>

            </ul>
        </nav>
        <!-- End Sidebar navigation -->
    </div>
    <!-- End Sidebar scroll-->

    <!-- <div class="image" style="width: 95%; height: 100%;text-align: center;margin: 0 auto;">
    <img src="./assets/images/SICAI4.png" class="img-fluid"  style="width: 95%;height: 25%;margin-top: -140px;">

    </div> -->






</aside>
<!-- ============================================================== -->
<!-- End Left Sidebar - style you can find in sidebar.scss  -->
<!-- ============================================================== -->